import { TranslationObject } from "./fr";

export const lv: TranslationObject = {
  quick_share: {
    title: "Ātra kopīgošana",
  },
  notifications: {
    unmanaged_error: "Radās neparedzēta kļūda",
  },
  users: {
    citizen: "Iedzīvotājs",
    pro: "Veselības aprūpes speciālists",
    team: "Aprūpes komanda",
  },
  injectionLocations: {
    left_deltoid: "Kreisais deltoīds",
    right_deltoid: "Labais deltoīds",
    left_thigh: "Kreisais augšstilbs",
    right_thigh: "Labais augšstilbs",
    null: "",
  },
  injectionMethods: {
    intramuscular: "Intramuskulāri",
    subcutaneous: "Zemādas",
    intradermal: "Intradermāli",
    oral: "Mutiski",
    intranasal: "Intranasāli",
    null: "",
  },
  sharingRequestStatus: {
    accepted: "Pieņemts",
    pending: "Gaida",
    rejected: "Noraidīts",
  },
  patient: "Pacienti",
  pro: "Veselības aprūpes speciālists",
  recommandations: {
    DiagnosticList: {
      infosMessage: "Vakcinācijas lēmumu pieņemšanas sistēma seko veselības iestāžu ieteikumiem.",
    },
  },
  diagnostic: {
    conclusion: {
      up_to_date: "Aktuāls",
      late: "Kavēta vakcinācija",
      to_do: "Izpildāms",
    },
    nextVaccination: "Nākamā vacinācija %{targetedDate}",
    specialCase: "Ziņots par īpašu gadījumu",
    contraindicated: "Ziņota kontrindikācija",
  },
  profile: {
    closeQuestionnaireCta: "Aizvērt veselības anketu",
    noConditions: "Nav raksturlielumu",
    addConditionCta: "Pievienot raksturlielumu",
    shortTitle: "Profils",
    conditionsTitle: "Norādītie raksturlielumi",
    questionnaireTitle: "Aizpildiet šeit veselības profilu",
    deleteCondition: {
      title: "Dzēst raksturlielumu",
      content: "Vai tiešām vēlaties dzēst šo raksturlielumu?",
    },
    validated: "Apstiprināts profils",
    validated_info_msg:
      "Profesionāļa apstiprinātu veselības profilu veselības kartes turētājs vairs nevar mainīt. Lai veiktu jebkādas izmaiņas šajā profilā, vērsieties pie veselības aprūpes speciālista (ārsta, farmaceita, medmāsas vai vecmātes).",
    not_validated_info_msg: "Jūsu veselības profils nav apstiprināts.",
    validatedBy: "Apstiprinājis %{certificator}",
    validatedByAPro: "Apstiprinājis veselības speciālists",
  },
  notes: {
    title: "Piezīmes",
    unknownAuthor: "Nezināms autors",
    lastModified: "Modificēts pirms %{distance}",
    addedAt: "Pievienots pirms %{distance}",
  },
  common: {
    subscribed:
      "Speciālists, kā MyVaccines.net tīkla dalībnieks, piemēro labu vakcinācijas praksi un var apstiprināt jūsu vai jūsu tuvinieku vakcinācijas vēsturi.",
    subscribedLogo:
      "Logotips norāda, ka šis speciālists kā MyVaccines.net tīkla dalībnieks piemēro īsteno labu vakcinācijas praksi un var apstiprināt jūsu vai jūsu ģimenes vakcinācijas vēsturi.",
    helpCenter: "Palīdzības centrs",
    createHelpTicket: "Sazināties ar mums",
    and: "un",
    others: "Citi",
    loading: "Ielādē…",
    navbar: {
      title: "Vakcinācijas ieteikumi",
      subtitle: "Jums un jūsu tuviniekiem",
    },
    copied: "Nokopēts!",
    retry: "Mēģināt vēlreiz",
    cta: {
      previous: "Iepriekšējais",
      back: "Atpakaļ",
      next: "Nākamais",
      save: "Saglabāt",
      add: "Pievienot",
      edit: "Rediģēt",
      delete: "Dzēst",
      cancel: "Atcelt",
      print: "Izdrukāt",
      close: "Aizvērt",
      reset: "Atiestatīt",
      submit: "Iesniegt",
      savePdf: "PDF",
      validate: "Apstiprināt",
      logout: "Izrakstīties",
      accept: "Apstiprināt",
      reject: "Noraidīt",
      remove: "Noņemt",
      search: "Meklēt",
      view: "Apskatīt",
      copy: "Kopētājs",
      send: "Nosūtīt",
      download: "Lejupielādēt",
      preview: "Priekšskatīt",
      confirm: "Apstiprināt",
    },
    errors: {
      title: "Kļūda %{statusCode}",
      title_unknown: "Nezināma kļūda",
      404: "Pieprasītā lapa neeksistē.",
      401: "Jums nav piekļuves tiesību šai lapai.",
      default: "Radās neparedzēta kļūda, mūsu tehniskā komanda ir informēta.",
      noResults: "Nav rezultātu",
      securityNumber: "Nederīgs sociālās apdrošināšanas numurs",
      zipCode: "Nederīgs pasta indekss",
      birthDate: "Nederīgs dzimšanas datums",
    },
    gender: {
      m: "Vīrietis",
      f: "Sieviete",
      s: "Dzimums",
    },
    conditions: {
      at: "pie",
      equalTo: "ir vienāds ar",
    },
    dates: {
      "DD/MM/YYYY": "DD/MM/GGGG",
      "MM/DD/YYYY": "MM/DD/GGGG",
      "DD.MM.YYYY.": "DD.MM.GGGG.",
      bornThe: "dzimis %{birthDate}",
      day: "diena |||| dienas",
      month: "mēnesis |||| mēneši",
      week: "nedēļa |||| nedēļas",
      year: "gads |||| gadi",
      toDoIn: "Jāveic pēc",
      toDoAsap: "Jāveic pēc iespējas ātrāk",
      lastModified: "Modificēts pirms %{distance}",
      addedAt: "Pievienots pirms %{distance}",
      processedAt: "Apstrādāts pirms %{distance}",
    },
    interface: {
      language: "valoda",
      patients: "Pacienti",
      unshared_health_records: "Arhivētie ieraksti",
      pending_sharing_requests: "Gaidošie koplietošanas pieprasījumi",
      informations: "Mans konts",
      sort_by: "Kārtot pēc",
      back_to_home: "Atpakaļ uz sākumlapu",
      reconnect: "Pieslēgties vēlreiz",
    },
    user_infos: {
      title: "Lūdzu, pārbaudiet sniegto informāciju precizitāti",
      first_names: "Vārds(i)",
      first_name: "Vārds",
      last_name: "Dzimšanas uzvārds",
      usual_name: "Izmantotais uzvārds",
      customary_name: "Izmantotais uzvārds",
      birth_date: "Dzimšanas datums",
      social_security_number: "Sociālās apdrošināšanas numurs",
      social_security_number_infos:
        "Lūdzu, ievadiet sociālās apdrošināšanas numuru, lai automātiski aizpildītu dzimumu, mēnesi un dzimšanas gadu",
      phone: "Tālrunis",
      address: "Adrese",
      zip_code: "Pasta indekss dzīvesvietai",
      city: "Pilsēta",
      country: "Valsts",
      placeholder: "Meklēt pēc vārda, dzimšanas datuma un/vai NIR",
      birth_place: "Dzimšanas vieta",
      birth_zip_code: "Dzimšanas vietas pasta indekss",
      birth_country: "Dzimšanas valsts",
    },
    alerts: {
      alert_notification: "Radās kļūda, mūsu tehniskā komanda ir informēta.",
      alert_classic: "Radās kļūda.",
      alert_profile: "Jūsu profils ir atjaunināts.",
      alert_auth: "Radās kļūda autentifikācijas laikā, mūsu tehniskā komanda ir informēta.",
      alert_auth_info: "Tas var notikt, piemēram, ja mēģināt ieiet sistēmā no ārzemēm.",
      alert_auth_info_support: "Lai saņemtu papildu informāciju, lūdzu, sazinieties ar atbalsta dienestu.",
      alert_logout: "Jūs esat izrakstījies",
      alert_logout_long: "Jūsu sesija ir beigusies, lūdzu, piesakieties vēlreiz.",
      alert_saved_success: "Izmaiņas saglabātas",
      alert_auth_failed: "Autentifikācija neizdevās",
    },
    city: {
      placeholder: "piem: Bordo vai 33000",
    },
    save: "Saglabāt",
    cancel: "Atcelt",
  },
  informations: {
    title: "Kontu pārvaldība",
  },
  sharing_requests: {
    status: "Nav gaidāmu koplietošanas pieprasījumu",
    pending_requests: "Koplietošana vēl nav pabeigta",
    notification: "Jūs tiksiet informēts, ja pacienta karte tiks koplietota ar jums.",
    error: "Radās kļūda.",
    success: "Pieprasījums veiksmīgi apstrādāts.",
    reject: "Noraidīt koplietošanas pieprasījumu",
    reject_validation: "Vai tiešām vēlaties noraidīt šo koplietošanas pieprasījumu?",
  },
  patients: {
    add: "Pievienot pacientu",
    none: "Nav pacientu",
    nothing: "Nav norādīts",
    title: "Pacienti",
    tabs: {
      immunization: "Saņemtās vakcīnas",
      vaccinations_to_be_done: "Vakcinācijas statuss",
      profile: "Veselības profils",
      travel: "Ceļojums",
      identity: "Identitāte",
      share: "Koplietošana",
      documents: "Dokumenti",
      appointments: "Tikšanās",
    },
    certificate: "Sertifikāts",
    vaccinationHistory: "Vakcinācijas vēsture",
    vaccinationHistoryAndStatus: "Vakcinācijas vēsture un statuss",
  },
  travel: {
    title: "Ceļojumi",
    count: "%{smart_count} ceļojums |||| %{smart_count} ceļojumi",
    add: "Jauns ceļojums",
    new_title: "Jauns ceļojums",
    create: "Izveidot ceļojumu",
    update: "Atjaunināt",
    view_diagnostic: "Skatīt diagnozi",
    diagnostic_selector_label: "Ceļojums",
    diagnostic_panel_title: "Ceļojums diagnozei",
    diagnostic_panel_description: "Diagnoze apvieno pacienta profilu ar izvēlēto ceļojumu.",
    diagnostic_without_travel: "Bez ceļojuma — vispārīga diagnoze",
    summary_destinations: "Galamērķis",
    summary_period: "Periods",
    summary_stay: "Uzturēšanās veids",
    questionnaire_answers: "Ceļojuma anketa",
    past: "Pagājis",
    mock_data_notice: "Šie ceļojumi ir pagaidu demonstrācijas dati, kamēr aizmugursistēma nav pieejama.",
    open: "Skatīt un rediģēt ceļojumu uz %{destinations}",
    no_destination: "Ceļojums bez galamērķa",
    back_to_list: "Atpakaļ uz ceļojumiem",
    delete: "Dzēst ceļojumu",
    delete_confirmation: "Vai tiešām vēlaties dzēst ceļojumu uz %{destinations}?",
    period: "No %{startDate} līdz %{endDate}",
    iframe_title: "Ceļojuma informācija",
    iframe_error: "Pašlaik ceļojumu nevar ielādēt.",
    staying_conditions: {
      comfortable: "Komfortabla uzturēšanās",
      intermediate: "Vidēja līmeņa uzturēšanās",
      adventurous: "Piedzīvojumu uzturēšanās",
    },
  },
  vaccines: {
    count: "%{smart_count} vakcinācija |||| %{smart_count} vakcinācijas",
    placeholder: "piem.: Gripas vakcīna",
    distributionDate: "pieejams kopš %{date}",
    title: "Vakcinācijas",
    error_messages: {
      error_1: "Vakcināciju nevar veikt nākotnē vai pirms dzimšanas datuma.",
      error_2: "Vakcināciju nevar veikt pēc vakcīnas derīguma termiņa beigām.",
      error_3: "Injekcijas metode nav pareiza.",
      error_4: "Administrācijas vieta nav pareiza.",
    },
    validate: "Apstiprināt vakcināciju",
    validated: "Apstiprināts akts",
    not_validated: "Neapstiprināts akts",
    aProfessional: "veselības speciālists",
    aTeam: "veselības aprūpes komanda",
    aTeamMember: "komandas %{teamInfo} speciālists",
    validatedUponExecutionBy: "Apstiprināts %{date}, izpildīja %{certificator}",
    validatedUponProofBy: "Apstiprināts pēc pierādījuma %{date} ar %{certificator}",
    editableByProOnly: "Tikai veselības speciālists, kas veica šo aktu, var to rediģēt",
    editableByTeamOnly: "Tikai komandas locekļi, kas veica šo aktu, var to rediģēt",
    editableByAnyPro: "Tikai veselības speciālists var to rediģēt",
    confirmation: {
      validate: "Es apstiprinu šo aktu, uzrādot sertifikātu vai veselības ierakstu",
      do_validate: "Es veicu šo aktu un apstiprinu to",
    },
    no_vaccinations: "Nav reģistrētu vakcināciju",
    no_vaccinations_sub: "Nav vakcināciju šajā veselības ierakstā koplietošanas pārtraukšanas datumā",
    administration_date: "Administrācijas datums",
    administered_the: "Administrēts ",
    administration: "Administrēts %{date} %{age} vecumā.",
    administration_country: "Administrēts %{date} %{age} vecumā valstī %{country}.",
    administered_at: " vietā ",
    name: "Vakcīnas nosaukums",
    name_or_disease: "Vakcīnas vai slimības nosaukums",
    add_vaccination: "Pievienot vakcināciju",
    add_vaccination_msg: "Pievienojiet savas vakcinācijas, lai sekotu vakcinācijas statusam.",
    scan_evc: "Skenēt EVC",
    scan_evc_dialog_title: "Importēt vakcinācijas no EVC",
    scan_evc_parsing: "Notiek sertifikāta parsēšana...",
    scan_evc_parse_error: "Neizdevās parsēt sertifikātu.",
    scan_evc_scan_label: "Skenēt QR kodu",
    scan_evc_upload_label: "Augšupielādēt EVC dokumentu",
    scan_evc_step_scan: "Skenēšana",
    scan_evc_step_preview: "Priekšskatījums",
    scan_evc_step_import: "Imports",
    scan_evc_camera_hint: "Ievietojiet QR kodu rāmī",
    scan_evc_upload_pdf: "Augšupielādēt PDF",
    scan_evc_no_token: "EVC nav atrasts",
    scan_evc_pdf_error: "Neizdevās nolasīt PDF",
    scan_evc_preview_title: "Sertifikāta dati",
    scan_evc_preview_name: "Vārds",
    scan_evc_preview_dob: "Dzimšanas datums",
    scan_evc_preview_vaccinations: "Vakcinācijas",
    scan_evc_preview_issuer: "Izdevējs",
    scan_evc_name_mismatch_warning:
      "Identitāte neatbilst. Lūdzu, pārliecinieties, ka šis EVC pieder tai pašai personai kā veselības ieraksts.",
    scan_evc_name_mismatch_tooltip: "Veselības ieraksta vārds: %{name}",
    scan_evc_birthdate_mismatch_tooltip: "Veselības ieraksta dzimšanas datums: %{birthdate}",
    scan_evc_all_present: "Visas vakcinācijas no šī EVC jau ir veselības ierakstā.",
    scan_evc_preview_summary: "%{selected} no %{new} jaunajām vakcinācijām tiks pievienotas (%{exact} jau ir).",
    scan_evc_preview_date: "Datums: %{date}",
    scan_evc_preview_country: "Valsts: %{country}",
    scan_evc_preview_diseases: "Slimības: %{diseases}",
    scan_evc_status_exact: "Jau ir",
    scan_evc_status_likely: "Jāpārskata",
    scan_evc_status_new: "Jauna",
    scan_evc_select_to_add: "Pievienot",
    scan_evc_import_summary: "%{selected} vakcinācija(s) atlasīta(s) pievienošanai.",
    scan_evc_add_selected: "Pievienot atlasītās vakcinācijas",
    scan_evc_submitting: "Pievieno vakcinācijas...",
    scan_evc_done: "Imports pabeigts",
    scan_evc_error_label: "Kļūda",
    scan_evc_missing_vaccine: "Vakcīna nav atrasta (NUVA %{nuvaCode})",
    scan_evc_missing_health_record: "Veselības ieraksts nav atrasts.",
    scan_evc_submit_error: "Neizdevās pievienot vakcinācijas.",
    scan_evc_operation_pending: "Gatavs",
    scan_evc_operation_loading: "Pievieno...",
    scan_evc_operation_success: "Pievienots",
    scan_evc_operation_error: "Neizdevās",
    scan_evc_import_summary_success: "%{count} vakcinācija(s) pievienota(s).",
    scan_evc_import_placeholder: "Imports drīzumā būs pieejams.",
    scan_evc_scan_again: "Skenēt vēlreiz",
    view_vaccination: "Apskatīt vakcināciju",
    edit_vaccination: "Rediģēt vakcināciju",
    delete_vaccination: "Dzēst vakcināciju",
    delete_vaccination_validation: "Vai tiešām vēlaties dzēst šo vakcināciju?",
    date_act: "Vakcinācijas datums",
    act_date_greater_than_expiration_date: "Akta datumā derīguma termiņš ir beidzies",
    expiration_date: "Derīguma termiņš",
    more: "Rādīt vairāk vakcīnu",
    serial_number: "Sērijas numurs",
    batch_number: "Partijas numurs",
    booster: "Pastiprinātājs",
    injection_location: "Administrācijas vieta",
    injection_path: "Administrācijas metode",
    additional_information: "Detalizēti dati",
    printCertified: "Tikai apstiprinātas vakcīnas var tikt izdrukātas",
    addVaccinationConfirmed: "Vakcinācija veiksmīgi pievienota",
    addVaccinations: {
      title: "Vakcinācijas, kas jāsaglabā",
      no_vaccines_added: "Nav pievienotu vakcīnu, lūdzu, izmantojiet formu",
    },
    addVaccinationType: {
      simple_entry: "Vienkārša ievade",
      simple_entry_subtitle: "Vienas vakcīnas ievade ar visām detaļām",
      multiple_entry: "Vairāku ievade",
      multiple_entry_subtitle: "Vairāku vakcīnu ievade bez detaļām",
      modal: {
        title: "Veselības ieraksta atjaunināšana",
        description:
          "Lai nodrošinātu vislabāko aizsardzību jūsu bērnam, lūdzu, atjauniniet vai pārbaudiet vakcinācijas informāciju. Tas aizņems tikai dažas minūtes un palīdzēs jums saglabāt medicīnisko ierakstu pilnīgu un aktuālu. Dodieties uz vakcināciju sadaļu un pārliecinieties, ka viss ir kārtībā.",
      },
    },
    addSimilarVaccination: {
      title: "Līdzīga vakcinācija",
      details:
        "Šim pacientam jau ir līdzīga vakcinācija ar līdzīgu vakcīnu tajā pašā datumā. Vai tiešām vēlaties to pievienot?",
    },
    vaccinesDistributed: "Vakcīnas pieejamas norādītajā datumā",
    otherVaccines: "Citas vakcīnas (pieejamas ārzemēs, ģeneriskas vai vecākas)",
    distributedSince: "Pieejams kopš %{distributionStart}",
    distributedBetween: "Pieejams no %{distributionStart} līdz %{distributionEnd}",
    displayByDiseases: "Slimība",
  },
  health_records: {
    title: "Mani veselības ieraksti",
    success: "Veselības ieraksts veiksmīgi atjaunināts.",
    add_success: "Veselības ieraksts veiksmīgi pievienots.",
    open_added_hr: "Atvērt pievienoto veselības ierakstu",
    delete_hr: "Dzēst veselības ierakstu",
    delete_hr_validation_intro_1: "Šī darbība ir neatgriezeniska: ",
    delete_hr_validation_intro_2: "ieraksts, saistītās vakcinācijas un veselības profils tiks neatgriezeniski dzēsti.",
    delete_hr_validation: "Lai apstiprinātu šo darbību, lūdzu, ievadiet dzēšamā ieraksta turētāja dzimšanas datumu:",
    date_format: "DD.MM.YYYY",
    none: "Nav veselības ierakstu",
    add_hr: "Pievienot veselības ierakstu",
    add_this_hr: "Pievienot šo veselības ierakstu",
    add_shared_hr: "Pievienot kopīgotu veselības ierakstu",
    need_connection_title: "Autentificēšanās...",
    need_connection: "Lai iegūtu šo veselības ierakstu, jums jāreģistrējas vai jāpiesakās savā MyVaccines.net kontā.",
    none_unshared: "Nav nekopīgotu veselības ierakstu.",
    none_shared: "Nav koplietošanas",
    share_button: "Kopīgot šo veselības ierakstu",
    share_button_2: "Kopīgot veselības ierakstu",
    share_pros: "Kopīgot veselības ierakstu ar citiem veselības speciālistiem",
    share_pro: "Kopīgot ar veselības speciālistu",
    share_msg: "Kopīgojiet šo veselības ierakstu ar veselības speciālistiem un ģimeni",
    share_msg_2: "Izveidojiet jaunus veselības ierakstus vai piekļūstiet ģimenes ierakstiem, izmantojot koplietošanu",
    sharing_request_sent: "Koplietošanas pieprasījums nosūtīts.",
    cancel_invite: "Atcelt ielūgumu",
    cancel_invite_validation: "Vai tiešām vēlaties atcelt šo ielūgumu?",
    search_other_pro: "Meklēt citu veselības speciālistu",
    share: "Kopīgot",
    copy_share_link: "Kopēt koplietošanas saiti",
    copy_share_link_msg: "Noklikšķinot zemāk, jūs nokopēsiet koplietošanas saiti savā starpliktuvē.",
    copy_share_link_success: "Saite nokopēta starpliktuvē.",
    attestation: "Es apliecinu, ka esmu pilnvarots kopīgot šo veselības ierakstu.",
    history: "Šeit atrodams visu veselības ierakstu vēsture, kuriem esat piekļuvis",
    create_or_access:
      "Izveidojiet jaunus pacientus vai piekļūstiet esošiem veselības ierakstiem, izmantojot koplietošanu",
    remove_from_patients: "Noņemt veselības ierakstu no maniem pacientiem",
    remove_from_patients_validation: "Vai tiešām vēlaties noņemt šo ierakstu no pacientu saraksta?",
    revoke: "Atsaukt",
    revoke_access: "Atsaukt piekļuvi",
    revoke_access_start: "Vai tiešām vēlaties atsaukt piekļuvi ierakstam ",
    revoke_access_end_citizen: ": šim speciālistam vairs nebūs piekļuves šim ierakstam",
    revoke_access_end_pro: ": šim speciālistam vairs nebūs piekļuves šim ierakstam",
    revoke_access_end_team: ": šīs aprūpes komandas speciālistiem vairs nebūs piekļuves šim ierakstam.",
  },
  share: {
    identity_error: {
      title: "Nepilnīga identitāte",
      description: "Lai kopīgotu savu veselības ierakstu, lūdzu, aizpildiet savu identitāti",
      cta: "Aizpildīt manu identitāti",
    },
    shared: "Kopīgots",
    browse_professional_directory:
      "Pārlūkojiet direktoriju, lai izvēlētos veselības speciālistu vai aprūpes komandu, kurai vēlaties piešķirt piekļuvi jūsu veselības ierakstam.",
    errors: {
      error_1:
        "Nepareizs dzimšanas datums. Jūs esat pārsniedzis iespējamo mēģinājumu skaitu, lūdzu, lūdziet veselības ieraksta īpašniekam citu koplietošanas saiti.",
      error_2: "Nepareizs dzimšanas datums. Jums ir atlicis viens mēģinājums pievienot veselības ierakstu.",
      error_3:
        "Nepareizs dzimšanas datums. Jums ir atlikuši %{remaining_attempts} mēģinājumi pievienot veselības ierakstu.",
      error_4: "Nepareiza koplietošanas saite vai pārsniegts mēģinājumu skaits.",
      error_5: "Radās kļūda, mūsu tehniskā komanda ir informēta. Lūdzu, mēģiniet vēlreiz vēlāk.",
    },
    with_a_health_professional: "Kopīgot šo veselības ierakstu ar veselības speciālistu",
    with_another_user: "Kopīgot šo veselības ierakstu ar draugu",
    with_its_owner: "Pārsūtīt šo veselības ierakstu",
    share_the_health_record: "Kopīgot veselības ierakstu",
    grant_ownership_disclaimer_1:
      "Jūs gatavojaties kopīgot šo veselības ierakstu ar radinieku. Piemēram: Pārsūtīt veselības ierakstu savam pilngadīgajam bērnam.",
    grant_ownership_disclaimer_2: "Noklikšķinot zemāk, jūs nokopēsiet koplietošanas saiti savā starpliktuvē.",
    grant_ownership_disclaimer_3:
      "Kad saite ir nokopēta, varat to ielīmēt e-pastā, SMS utt. un nosūtīt attiecīgajai personai.",
    share_with_citizen_disclaimer_1:
      "Jūs gatavojaties kopīgot šo veselības ierakstu ar draugu. Piemēram: Kopīgot bērna veselības ierakstu ar otru vecāku.",
    link_copied: "Saite nokopēta",
    generate_sharing_link: "Kopīgot",
    transfer: "Pārsūtīt",
    link_copied_to_clipboard: "Saite ir nokopēta starpliktuvē",
    copy_sharing_link: "Kopēt koplietošanas saiti",
    email_sharing: "Kopīgot, nosūtot e-pastu:",
    email_sharing_description:
      "Paziņojiet tuvākajam, ka saite ir derīga tikai 30 dienas. Ja viņš to nesaņem uzreiz, lai pārbauda SPAM.",
    email_grant_ownership: "Pārsūtiet šo ierakstu draugam vai ģimenes loceklim, nosūtot e-pastu:",
    email_sent: "Email successfully sent to <<%{email}>>",
    share_link: "Kopējiet šo saiti un kopīgojiet to ar radinieku pēc saviem ieskatiem",
    grant_ownership_link: "Kopējiet šo saiti un kopīgojiet to pēc saviem ieskatiem",
    share_link_description: "Šo saiti var kopīgot ar SMS vai e-pastu.",
    qrcode_share: "Lūdziet draugam vai ģimenes loceklim noskenēt šo QR kodu, lai kopīgotu ierakstu:",
    qrcode_share_description: "Ātra metode: ieteicama, ja tuvākajam ir viedtālrunis.",
    qrcode_grant_ownership: "Skenējiet QR kodu, lai kļūtu par īpašnieku",
    or: "VAI",
    sms_grant_ownership: "Piešķirt īpašumtiesības, nosūtot SMS:",
    sms_share: "Piešķirt piekļuvi, nosūtot SMS:",
    withdraw: "Atsaukt",
    withdraw_hr: "Atsaukt veselības ierakstu",
    withdraw_hr_validation: "Vai tiešām vēlaties atsaukt piekļuvi šim veselības ierakstam?",
    rpps_number: "RPPS numurs: ",
    security_msg: "Drošības nolūkos, lūdzu, ievadiet kopīgotā veselības ieraksta īpašnieka dzimšanas datumu",
    attest: "Es apliecinu, ka esmu pilnvarots piekļūt šim ierakstam",
    share_with_team_disclaimer:
      "Piezīme: Veselības ieraksts, kas kopīgots ar aprūpes komandu, būs pieejams visiem tās locekļiem.",
    other_share_methods: "Citas koplietošanas metodes (QR kods, saite)",
    other_transfer_methods: "Citas pārsūtīšanas metodes (QR kods, saite)",
    generate_pdf: "Izdrukāt QR kodu",
  },
  pdfView: {
    shareHealthRecord: "Šo ierakstu ar jums dalās %{user}",
    qrCode: "Šis QR kods ir derīgs līdz %{date}",
    vaccinesList: "Pacienta vakcīnu saraksts līdz šim (%{date})",
  },
  account: {
    email: "E-pasts",
    password: "Parole",
    mobile: "Mobilā tālruņa numurs",
    infos:
      "Jūsu e-pasta adrese un parole ir jūsu pieteikšanās dati. Mobilā tālruņa numurs ļauj izmantot divu faktoru autentifikāciju, kas nodrošina jūsu konta drošību. Jūsu personas dati netiks izmantoti komerciāliem nolūkiem.",
    vaccination_reminders: "Sūtīt man atgādinājumus par vakcināciju pa e-pastu",
    vaccination_reminders_infos:
      "Atzīmējiet šo izvēles rūtiņu, ja vēlaties saņemt paziņojumus par nokavētām vai tuvāko 30 dienu laikā veicamām vakcinācijām.",
  },
  datamatrix: {
    dialogTitle: "Skenēt datamatrix kodu",
    preventionMethod: "Vakcīna: ",
    serialNumber: "Sērijas numurs: ",
    batchNumber: "Partijas numurs: ",
    expirationDate: "Derīguma termiņš: ",
    scanCta: "Skenēt datamatrix kodu",
    loading: "Notiek serveru vaicāšana",
    noDeviceError: "Jūsu ierīcē nav konstatēta kamera.",
    notFoundToast: "Mūsu serveros nav atrasta vakcīnas atbilstība, lūdzu, norādiet vakcīnas nosaukumu manuāli.",
    scanError: "Radās kļūda, skenējot datamatrix kodu, lūdzu, mēģiniet vēlreiz.",
    serverError: "Radās kļūda, mēģinot piekļūt vakcīnu datubāzei, lūdzu, mēģiniet vēlreiz.",
    successToast: "Veidlapas lauki aizpildīti ar skenēšanas rezultātiem.",
    camera: {
      tabTitle: "Kamera",
      steps: {
        "1": "Novietojiet datamatrix kodu dzeltenajā kvadrātā",
        "2": "Informācijas meklēšana notiek automātiski",
        "3": "Uznirstošais logs automātiski aizvērsies un aizpildīs veidlapu",
      },
    },
    barCodeScanner: {
      tabTitle: "Svītrkoda skeneris",
      steps: {
        "1": "Skenējiet kodu ar svītrkoda skeneri",
        "2": "Kods parādīsies teksta laukā",
        "3": "Noklikšķinot uz svītrkoda lasītāja, logs automātiski aizvērsies un aizpildīs veidlapu",
      },
    },
    inverseImage: "Apgriezt kameras attēlu",
  },
  healthProfessional: {
    rppsNumber: "RPPS numurs",
    noRppsNumber: "Nav RPPS numura",
  },
  team: {
    identificationNumber: "Identifikācijas numurs",
  },
  yup: {
    mixed: {
      default: "nav derīgs",
      required: "ir obligāts lauks",
      oneOf: "jābūt vienai no šādām vērtībām: %{values}",
      notOneOf: "nedrīkst būt viena no šādām vērtībām: %{values}",
      defined: "ir obligāts lauks",
    },
    string: {
      length: "jābūt tieši %{length} rakstzīmēm",
      min: "jābūt vismaz %{min} rakstzīmēm",
      max: "jābūt ne vairāk kā %{max} rakstzīmēm",
      matches: "nav derīgs un jāatbilst prasītajam formātam",
      email: "jābūt derīgam e-pastam",
      url: "jābūt derīgai URL adresei",
      uuid: "jābūt derīgam UUID",
      trim: "jābūt apgrieztai virknei",
      lowercase: "jābūt mazajiem burtiem",
      uppercase: "jābūt lielajiem burtiem",
    },
    number: {
      min: "jābūt lielākam vai vienādam ar %{min}",
      max: "jābūt mazākam vai vienādam ar %{max}",
      lessThan: "jābūt mazākam par %{less}",
      moreThan: "jābūt lielākam par %{more}",
      positive: "jābūt pozitīvam skaitlim",
      negative: "jābūt negatīvam skaitlim",
      integer: "jābūt veselam skaitlim",
    },
    date: {
      min: "lauks jābūt %{min} vai vēlāk",
      max: "lauks jābūt %{max} vai agrāk",
      invalid: "nav derīgs datums",
    },
    boolean: {
      isValue: "lauks jābūt %{value}",
    },
    object: {
      noUnknown: "laukā ir nenoteiktas atslēgas: %{unknown}",
    },
    array: {
      min: "laukā jābūt vismaz %{min} elementiem",
      max: "laukā jābūt ne vairāk kā %{max} elementiem",
      length: "jābūt %{length} elementiem",
    },
  },
  countries: {
    AFG: "Afganistāna",
    ALB: "Albānija",
    DZA: "Alžīrija",
    ASM: "Amerikāņu Samoa",
    AND: "Andora",
    AGO: "Angola",
    AIA: "Angilja",
    ATA: "Antarktīda",
    ATG: "Antigva un Barbuda",
    ARG: "Argentīna",
    ARM: "Armēnija",
    ABW: "Aruba",
    AUS: "Austrālija",
    AUT: "Austrija",
    AZE: "Azerbaidžāna",
    BHS: "Bahamas",
    BHR: "Bahreina",
    BGD: "Bangladeša",
    BRB: "Barbadosa",
    BLR: "Baltkrievija",
    BEL: "Beļģija",
    BLZ: "Beliza",
    BEN: "Benina",
    BMU: "Bermudu salas",
    BTN: "Butāna",
    BOL: "Bolīvija",
    BES: "Bonaire, Sint Eustatius un Saba",
    BIH: "Bosnija un Hercegovina",
    BWA: "Botsvāna",
    BVT: "Buvē sala",
    BRA: "Brazīlija",
    IOT: "Britu Indijas okeāna teritorija",
    BRN: "Bruneja",
    BGR: "Bulgārija",
    BFA: "Burkinafaso",
    BDI: "Burundi",
    CPV: "Kaboverde",
    KHM: "Kambodža",
    CMR: "Kamerūna",
    CAN: "Kanāda",
    CYM: "Kaimanu salas",
    CAF: "Centrālāfrikas Republika",
    TCD: "Čada",
    CHL: "Čīle",
    CHN: "Ķīna",
    CXR: "Ziemsvētku sala",
    CCK: "Kokosu (Kīlinga) salas",
    COL: "Kolumbija",
    COM: "Komoru salas",
    COD: "Kongo (Demokrātiskā Republika)",
    COG: "Kongo",
    COK: "Kuka salas",
    CRI: "Kostarika",
    HRV: "Horvātija",
    CUB: "Kuba",
    CUW: "Kirasao",
    CYP: "Kipra",
    CZE: "Čehija",
    CIV: "Kotdivuāra",
    DNK: "Dānija",
    DJI: "Džibutija",
    DMA: "Dominika",
    DOM: "Dominikānas Republika",
    ECU: "Ekvadora",
    EGY: "Ēģipte",
    SLV: "Salvadora",
    GNQ: "Ekvatoriālā Gvineja",
    ERI: "Eritreja",
    EST: "Igaunija",
    SWZ: "Esvatini",
    ETH: "Etiopija",
    FLK: "Folklenda salas (Malvinas)",
    FRO: "Fēru salas",
    FJI: "Fidži",
    FIN: "Somija",
    FRA: "Francija",
    GUF: "Franču Gviāna",
    PYF: "Franču Polinēzija",
    ATF: "Franču Dienvidjūru teritorijas",
    GAB: "Gabona",
    GMB: "Gambija",
    GEO: "Gruzija",
    DEU: "Vācija",
    GHA: "Gana",
    GIB: "Gibraltārs",
    GRC: "Grieķija",
    GRL: "Grenlande",
    GRD: "Grenāda",
    GLP: "Gvadelupa",
    GUM: "Guama",
    GTM: "Gvatemala",
    GGY: "Gērnsija",
    GIN: "Gvineja",
    GNB: "Gvineja-Bisava",
    GUY: "Gajāna",
    HTI: "Haiti",
    HMD: "Hērda sala un Makdonalda salas",
    VAT: "Vatikāns",
    HND: "Hondurasa",
    HKG: "Honkonga",
    HUN: "Ungārija",
    ISL: "Islande",
    IND: "Indija",
    IDN: "Indonēzija",
    IRN: "Irāna",
    IRQ: "Irāka",
    IRL: "Īrija",
    IMN: "Mena sala",
    ISR: "Izraēla",
    ITA: "Itālija",
    JAM: "Jamaika",
    JPN: "Japāna",
    JEY: "Džērsija",
    JOR: "Jordānija",
    KAZ: "Kazahstāna",
    KEN: "Kenija",
    KIR: "Kiribati",
    PRK: "Ziemeļkoreja",
    KOR: "Dienvidkoreja",
    KWT: "Kuveita",
    KGZ: "Kirgizstāna",
    LAO: "Laosa",
    LVA: "Latvija",
    LBN: "Libāna",
    LSO: "Lesoto",
    LBR: "Libērija",
    LBY: "Lībija",
    LIE: "Lihtenšteina",
    LTU: "Lietuva",
    LUX: "Luksemburga",
    MAC: "Makao",
    MDG: "Madagaskara",
    MWI: "Malāvija",
    MYS: "Malaizija",
    MDV: "Maldīvija",
    MLI: "Mali",
    MLT: "Malta",
    MHL: "Māršala salas",
    MTQ: "Martinika",
    MRT: "Mauritānija",
    MUS: "Maurīcija",
    MYT: "Majota",
    MEX: "Meksika",
    FSM: "Mikronēzija",
    MDA: "Moldova",
    MCO: "Monako",
    MNG: "Mongolija",
    MNE: "Melnkalne",
    MSR: "Montserrata",
    MAR: "Maroka",
    MOZ: "Mozambika",
    MMR: "Mjanma",
    NAM: "Namībija",
    NRU: "Nauru",
    NPL: "Nepāla",
    NLD: "Nīderlande",
    NCL: "Jaunkaledonija",
    NZL: "Jaunzēlande",
    NIC: "Nikaragva",
    NER: "Nigēra",
    NGA: "Nigērija",
    NIU: "Niue",
    NFK: "Norfolkas sala",
    MNP: "Ziemeļu Marianas salas",
    NOR: "Norvēģija",
    OMN: "Omāna",
    PAK: "Pakistāna",
    PLW: "Palau",
    PSE: "Palestīna",
    PAN: "Panama",
    PNG: "Papua-Jaungvineja",
    PRY: "Paragvaja",
    PER: "Peru",
    PHL: "Filipīnas",
    PCN: "Pitkērna",
    POL: "Polija",
    PRT: "Portugāle",
    PRI: "Puertoriko",
    QAT: "Katara",
    MKD: "Ziemeļmaķedonija",
    ROU: "Rumānija",
    RUS: "Krievija",
    RWA: "Ruanda",
    REU: "Reinjona",
    BLM: "Senbartelmī",
    SHN: "Sv. Helēnas sala, Ascension un Tristana da Kunja",
    KNA: "Sentkitsa un Nevisa",
    LCA: "Sentlūsija",
    MAF: "Senmartēna (Francijas daļa)",
    SPM: "Senpjēra un Mikelona",
    VCT: "Sentvinsenta un Grenadīnas",
    WSM: "Samoa",
    SMR: "Sanmarīno",
    STP: "Santome un Prinsipi",
    SAU: "Saūda Arābija",
    SEN: "Senegāla",
    SRB: "Serbija",
    SYC: "Seišelu salas",
    SLE: "Sjerraleone",
    SGP: "Singapūra",
    SXM: "Sintmārtena (Nīderlandes daļa)",
    SVK: "Slovākija",
    SVN: "Slovēnija",
    SLB: "Zālamana salas",
    SOM: "Somālija",
    ZAF: "Dienvidāfrika",
    SGS: "Dienviddžordžija un Dienvidsendviču salas",
    SSD: "Dienvidsudāna",
    ESP: "Spānija",
    LKA: "Šrilanka",
    SDN: "Sudāna",
    SUR: "Surinama",
    SJM: "Svalbāra un Jana Majena",
    SWE: "Zviedrija",
    CHE: "Šveice",
    SYR: "Sīrija",
    TWN: "Taivāna",
    TJK: "Tadžikistāna",
    TZA: "Tanzānija",
    THA: "Taizeme",
    TLS: "Austrumtimora",
    TGO: "Togo",
    TKL: "Tokelau",
    TON: "Tonga",
    TTO: "Trinidāda un Tobāgo",
    TUN: "Tunisija",
    TUR: "Turcija",
    TKM: "Turkmenistāna",
    TCA: "Tērksas un Kaikosas salas",
    TUV: "Tuvalu",
    UGA: "Uganda",
    UKR: "Ukraina",
    ARE: "Apvienotie Arābu Emirāti",
    GBR: "Apvienotā Karaliste",
    UMI: "ASV Mazās Aizjūras Salas",
    USA: "Amerikas Savienotās Valstis",
    URY: "Urugvaja",
    UZB: "Uzbekistāna",
    VUT: "Vanuatu",
    VEN: "Venecuēla",
    VNM: "Vjetnama",
    VGB: "Britu Virdžīnu salas",
    VIR: "ASV Virdžīnu salas",
    WLF: "Volisa un Futuna",
    ESH: "Rietumsahāra",
    YEM: "Jemena",
    ZMB: "Zambija",
    ZWE: "Zimbabve",
    ALA: "Ālandu salas",
  },
  documents: {
    title: "Dokumenti",
    no_documents: "Nav dokumentu",
    add_document: "Pievienot dokumentu",
    add_files: "Pievienot failus",
    delete_document: "Dzēst dokumentu",
    delete_document_confirmation_message: "Vai tiešām vēlaties dzēst šo dokumentu?",
    delete_attachment: "Dzēst šo failu",
    delete_attachment_confirmation_message: "Vai tiešām vēlaties dzēst šo failu?",
    file: "fails",
    files: "faili",
    created_at: "Izveidots %{date}",
    info_msg: "Koplietošanas gadījumā veselības speciālisti var piekļūt šiem dokumentiem.",
    edit_document: "Rediģēt dokumentu",
    file_upload: {
      add_files: "Pievienot failus",
      add_more_files: "Pievienot vēl failus",
      file_types_allowed_info: "PDF, PNG, JPEG, TIFF (maks. %{size})",
      file_type_error: "Neatbalstīts faila tips",
      file_size_error: "Fails pārsniedz maksimālo izmēru (%{size})",
      total_size_error: "Kopējais failu izmērs pārsniedz %{size}",
      invalid_files: "Daži faili nav atbalstīti",
      drop_files: "Nometiet failus",
      drag_drop_or_browse: "Velciet un nometiet vai pārlūkojiet",
      files_summary: "%{amount} fails(i) • Kopā: %{totalSize}",
      in_queue: "Rindā",
      uploaded: "Pabeigts",
      uploading: "Augšupielāde: %{percent}%",
    },
    cta: {
      add: "Pievienot dokumentu",
      add_msg: "Pievienojiet dokumentus šim ierakstam",
    },
    attributes: {
      name: "Nosaukums",
      category: "Kategorija",
      createdAt: "Izveidots",
      date: "Datums",
      attachments: "Faili",
      categories: {
        vaccination_book: "Vakcinācijas grāmatiņa",
        letter: "Vēstule",
        parental_consent: "Vecāku piekrišana",
        biology: "Bioloģija",
        imagerie: "Attēlveidošana",
        other: "Cits",
      },
    },
  },
  appointments: {
    title: "Tikšanās",
    empty: "Nav tikšanās",
    allAppointments: "Visi pasākumi",
    bookAppointment: "Pieteikties uz vizīti",
    searchPlaceholder: "Meklēt pēc vārda, adreses, tālruņa numura...",
  },
  evc_onboarding: {
    title: "Importējiet savu vakcinācijas karti",
    step_detect: "Noteikšana",
    step_preview: "Priekšskatījums",
    step_import: "Imports",
    parsing: "Vakcinācijas sertifikāta analīze...",
    parse_error: "Nevar analizēt vakcinācijas sertifikātu.",
    welcome_message: "Mēs izveidosim jūsu veselības karti un importēsim jūsu vakcinācijas.",
    name: "Vārds",
    date_of_birth: "Dzimšanas datums",
    gender: "Dzimums",
    vaccinations_count: "Vakcinācijas",
    select_vaccinations: "Atlasiet importējamās vakcinācijas",
    vaccinations_summary: "%{selected} no %{total} vakcinācijām atlasītas",
    skip: "Izlaist",
    import_selected: "Importēt %{count} vakcināciju(-as)",
    importing_progress: "Importēšana... %{done}/%{total}",
    success_title: "Imports pabeigts!",
    success_message: "%{count} vakcinācija(-as) veiksmīgi importēta(-as).",
    success_with_errors: "%{imported} vakcinācija(-as) importēta(-as), %{errors} kļūda(-as).",
    view_health_record: "Skatīt manu veselības karti",
    continue_without_import: "Turpināt bez importēšanas",
    gender_required: "Lūdzu, izvēlieties dzimumu.",
    create_hr_error: "Nevar izveidot veselības karti.",
  },
  vaccinator: {
    firstName: "Vārds",
    lastName: "Uzvārds",
    vaccinator: "Vakcinētājs",
    namesRequired: "Ievadiet gan vakcinētāja vārdu, gan uzvārdu.",
    search: "Meklēt",
    searchInDirectory: "Meklēt Veselības katalogā",
    searchGuidance: "Meklējiet veselības aprūpes speciālistu, izmantojot zemāk esošo katalogu (dati iegūti no annuaire.esante.gouv.fr).",
  },
};
